<template>
  <div class="card card--white">
    <div class="card card--container">
      Doesn't look you've taken any assessments. Talk to your coach if you would like to. 
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
